export class ShiftPreferenceDay {
	public index;
	public day_of_week;
	
	constructor(obj) {
		this.index = obj.index;
		this.day_of_week = obj.day_of_week;
	}
} 
